// Environment-specific configuration

// Get the build environment from REACT_APP_ENV (set during build time)
// or fallback to NODE_ENV (runtime environment)
const getBuildEnv = () => {
  // During build time, this will be replaced with the actual value
  return process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
};

const buildEnv = getBuildEnv();

// Pricing configuration
export const PRICING = {
  PLANS: {
    MONTHLY: {
      ID: 'xx1',
      BASE_PRICE: 299,
      PERIOD: 'monthly',
      TOTAL_MONTHS: 12
    },
    YEARLY: {
      ID: 'xx2',
      BASE_PRICE: 249,
      PERIOD: 'yearly',
      TOTAL_MONTHS: 12
    }
  },
  
  // Discount thresholds
  EXTREME_DISCOUNT_THRESHOLD_PERCENTAGE: 0.1, // 10% of original price
  
  // GST information
  GST: {
    NUMBER: '09AMWPB1798E1ZM',
    RATE: 18
  },
  
  // Branding colors
  BRAND_COLORS: {
    PRIMARY: [255, 107, 53] // RGB for YoungPresso orange
  }
};

/**
 * Calculate GST components from a total amount
 * @param {number} totalAmount - The total amount including GST
 * @returns {Object} Object containing baseAmount, gstAmount, and totalAmount
 */
export const calculateGstComponents = (totalAmount) => {
  const gstRate = PRICING.GST.RATE;
  const baseAmount = totalAmount / (1 + gstRate/100);
  const gstAmount = totalAmount - baseAmount;
  
  return {
    baseAmount: parseFloat(baseAmount.toFixed(2)),
    gstAmount: parseFloat(gstAmount.toFixed(2)),
    totalAmount: parseFloat(totalAmount.toFixed(2))
  };
};

/**
 * Check if a payment is extremely discounted
 * @param {number} originalAmount - The original amount before discount
 * @param {number} paidAmount - The amount paid after discount
 * @returns {boolean} True if the discount is extreme (below threshold)
 */
export const isExtremelyDiscounted = (originalAmount, paidAmount) => {
  return paidAmount / originalAmount < PRICING.EXTREME_DISCOUNT_THRESHOLD_PERCENTAGE;
};

const config = {
  // API URLs for different environments
  apiUrls: {
    development: 'http://localhost:5000',
    stage: 'https://youngpresso-73d540a3cc99.herokuapp.com',
    production: 'https://www.youngpresso.com'
  },
  
  // Feature flags
  features: {
    showAnalytics: buildEnv !== 'production'
  },
  
  // Razorpay configuration
  razorpay: {
    keyId: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_aQMtJrgSUcDcWB'
  },
  
  // API key
  apiKey: process.env.REACT_APP_API_KEY || '2a7dbc8e3e9e2cef5fd91ca229122815dc0bf453e057467e4ac77e998ba79da5'
};

// Get the current environment
const getEnvironment = () => {
  return buildEnv;
};

// Get the API URL for the current environment
const getApiUrl = () => {
  const env = getEnvironment();
  
  // In development, use the current hostname to support mobile access on local network
  if (env === 'development' && typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // If accessing via IP address (not localhost), use that IP for API calls
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      return `http://${hostname}:5000`;
    }
  }
  
  return config.apiUrls[env] || config.apiUrls.development;
};

// Export configuration and helper functions
export default {
  ...config,
  getEnvironment,
  getApiUrl,
  PRICING,
  calculateGstComponents,
  isExtremelyDiscounted
};
